import { useTranslations } from 'next-intl';
import { BlocksChangeEvent } from '@blocks-web-components/events';
import { CatSearchForm } from 'components/blocks-components';

export const MyEquipmentSearchInput = ({
  myEquipmentListLength,
  onSearch
}: {
  myEquipmentListLength: number;
  onSearch: (string: string) => void;
}) => {
  const t = useTranslations();
  const placeholderText = `${t('MEQ_SEARCH_TEXT')} (${myEquipmentListLength})`;
  const onBlChange = (e: BlocksChangeEvent): void =>
    onSearch(e.detail.value ?? '');

  return (
    // TODO - Input Validation - Ensure that <,>,/,\ characters and <script> tags are not allowed to type/paste.
    // TODO - Input Validation - Ensure that maximum query params length is 1024 characters
    <CatSearchForm
      mobileBreakPoint={0} // prevent search modal from opening when in mobile view
      size="md"
      placeholder={placeholderText}
      isEmpty
      data-testid="myEquipmentSearch"
      onBlChange={onBlChange}
    />
  );
};
